import { checkHttpStatus, parseJSON, expiredToken, errorResponse, successResponse } from '@utils/response';
import { Token, UserCode, AccessType, IsSupervisorMode } from '@users';
const CONTROLLER_ROUTE = IsSupervisorMode() ? 'Supervisor/' : '';

export function clearDBCache(origin) {
	return fetch(CONTROLLER_ROUTE + 'combo/clearCache', {
		method: 'post',
		credentials: 'include',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			userCode: UserCode(),
            accessType: AccessType(),
            origin,
			token: Token()
		})
	})
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
			return successResponse(response);
        })
        .catch(error => {
            return errorResponse(error);
        })
}